import React from "react";
import SingleContentPage from "../Shared/SingleContentPage";

const SiteSettings = () => {
  return <SingleContentPage title="Site Settings" moduleKey="site-settings" />;
};

export default SiteSettings;
